import { useEffect, useState } from "react";

export function useNavbarHeight() {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const navbar = document.querySelector("#navbar");
    if (!navbar) return;

    setHeight(navbar.getBoundingClientRect().height);

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setHeight(entry.contentRect.height);
      }
    });

    resizeObserver.observe(navbar);

    // Cleanup
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return height;
}
